module.exports = __webpack_public_path__ + "img/logo.3187ab44.png";